export default {
  getTaskDossierList(state) {
    return state.taskDossierList
  },
  getTaskDossier(state) {
    return state.taskDossier
  },
  getDataTransferObject(state) {
    return state.dataTransferObject
  }
}
